import { AccessibilityStoreState } from '@core/data-access/models/accessibility/accessibility-store.model';
import { AccessibilityFontSizePercentage } from '@core/data-access/models/accessibility/accessibility.model';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { accessibilityReducerKey } from './accessibility.reducer';

const accessibilityFeatureSelector = createFeatureSelector<AccessibilityStoreState>(accessibilityReducerKey);

export const selectIsHighContrastEnabled = createSelector(
  accessibilityFeatureSelector,
  ({ isHighContrastEnabled }) => isHighContrastEnabled
);

export const selectFontSizePercentage = createSelector(
  accessibilityFeatureSelector,
  ({ fontSizePercentage }) => fontSizePercentage
);

export const selectAreDefaultSettingsChanged = createSelector(
  accessibilityFeatureSelector,
  ({ isHighContrastEnabled, fontSizePercentage }) =>
    isHighContrastEnabled || fontSizePercentage !== AccessibilityFontSizePercentage.Default
);
